module.exports = __webpack_public_path__ + "static/img/WF.8b7be453.svg";